import React, { useEffect, useState } from "react";
import OrderFromYourFavResturant from "./orderFromYourFavoritResturant/OrderFromYourFavResturant";
import Selections from "./selections/Selections";
import LocationServe from "./locationServe/LocationServe";
import NewsLetter from "./newsLetter/NewsLetter";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_AUTO_APPLIED_COUPON,
  GET_CITY_SEO_DATA,
  GET_DEFAULT_ADDRESS,
  GET_STATE_INFO,
  SHOW_TICKER,
} from "store/Action/HomeAction";
import {
  ASAP_DATE,
  GET_ASAP_ADVANCE_TYPE,
  GET_DELIVERY_PICKUP_NOW_HIT,
  GET_DELIVER_PICKUP_TAB,
  GET_SERVICE_TYPE,
  GET_TIME,
} from "store/Action/RasturantAction";
import { useLocation, useNavigate } from "react-router-dom";
import {
  errorToast,
  errorWarningToast,
  successToast,
} from "utils/toastMessage";

import LottiLoader from "components/shared/Loader/LottiLoader";
import {
  GET_ALL_ADDRESS,
  GET_NEAREST_ADDRESS,
} from "store/Action/Sidebar/AddressAction";
import AddressAutoSplash from "components/addressAutoSplash/AddressAutoSplash";
import ReactHelmet from "components/shared/ReactHelmet/ReactHelmet";
import InstallPWA from "components/InstallPwa/InstallPwaButton";
import moment from "moment";
import "../home/Home.css";
import { GET_HIT_PLACE_ORDER_KEY } from "store/Action/CheckoutAction";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const useQuery = () => new URLSearchParams(useLocation().search);
  let query = useQuery();

  let searchQuery = query.get("coupon");
  const ssoToken = query.get("sso_tok");
  const isNewApp = query.get("is_new_app");
  const isMobileApp = query.get("is_mobile_app");
  const isGuestUser = query.get("is_guest");

  const Token = localStorage.getItem("access_token");
  const path = location.pathname.replace("/", "");

  // ALL SELECTORS
  const { ALL_ADDRESS, DEFAULT_ADDRESS, ASAP_CURRENT_DATE } = useSelector(
    (store) => ({
      ALL_ADDRESS: store.AddressReducer.allAddress,
      DEFAULT_ADDRESS: store?.ProfileReducer?.defaultAddress ?? {},
      ASAP_CURRENT_DATE: store?.ResturantReducer?.asapDate,
    })
  );

  //ALL STATE
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [initialLoader, setInitialLoader] = useState(true);
  const [showAddressFetching, setAddressFetching] = useState(true);
  /*  const [initialLoader, setInitialLoader] = useState(false);
  const [showAddressFetching, setAddressFetching] = useState(false); */

  const [addressLoading, setAddressLoading] = useState(false);
  const [showDownloadBtn, setShowDownloadBtn] = useState(true);
  const [visibilityInstall, setVisibilityInstalled] = useState(true);
  const [callAddrssApi, setCallAddressApi] = useState(false);

  useEffect(() => {
    if (ssoToken) {
      setTimeout(() => {
        if (isGuestUser === "yes") {
          sessionStorage.setItem("__g_access_token", ssoToken);
        } else {
          localStorage.setItem("access_token", ssoToken);
        }
      });
    }

    dispatch(SHOW_TICKER(false));
    dispatch(GET_CITY_SEO_DATA({}));
    setTimeout(() => {
      setVisibilityInstalled(false);
    }, 30000);
    window.scrollTo(0, 0, { behavior: "smooth" });
  }, [ssoToken]);

  useEffect(() => {
    if (searchQuery) {
      localStorage.setItem("is_promo_code_applied", "yes");
      dispatch(GET_AUTO_APPLIED_COUPON(searchQuery));
      setTimeout(() => {
        const isPromoCodeApplied = localStorage.getItem(
          "is_promo_code_applied"
        );
        if ((Token || ssoToken) && isPromoCodeApplied) {
          successToast("Promo code has been applied");
          localStorage.removeItem("is_promo_code_applied");
        } else {
          errorWarningToast("Sign up for exclusive coupons and save!");
        }
      }, 2000);
    }
  }, [Token, dispatch, searchQuery, ssoToken]);

  useEffect(() => {
    if (isMobileApp) {
      localStorage.setItem("is_mobile_app", "yes");
    }

    if (isNewApp) {
      localStorage.setItem("is_new_app", "yes");
    }

    //console.log("window._cordovaNative", window._cordovaNative);
    if (window._cordovaNative) {
      navigate("/force-update");
    }

    const standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);

    if (ios) {
      const newApp = localStorage.getItem("is_new_app");
      if (!newApp) {
        if (!standalone && !safari) {
          navigate("/force-update");
        }
      }
    }
  }, [isMobileApp, isNewApp, navigate]);

  useEffect(() => {
    setTimeout(() => {
      setAddressFetching(false);
      setInitialLoader(false);
    }, 15000);
  }, []);

  useEffect(() => {
    if (Token) {
      dispatch(
        GET_ALL_ADDRESS({}, (loading, error,addresses) => {
          setAddressFetching(loading);
            setInitialLoader(loading);
          if (!error) {
            
            //setCallAddressApi(!callAddrssApi);
          }
          if(!loading){
            autofetchLocationForLogInUser(addresses);
          }
        })
      );
    }
  }, [Token]);

  useEffect(() => {
    if (!Token) {
      setTimeout(() => {
        setAddressFetching(false);
        setInitialLoader(false);
      }, 1000);
      if (Object.keys(DEFAULT_ADDRESS).length !== 0) {
        if (DEFAULT_ADDRESS.entry_postcode) {
          navigate("/restaurants");
        }
      }
    } else if (Object.keys(DEFAULT_ADDRESS).length !== 0) {
      if (DEFAULT_ADDRESS.entry_postcode) {
        navigate("/restaurants");
      }
    }
  }, [!Token, DEFAULT_ADDRESS]);

  /* useEffect(() => {
    if (Token) {
      setTimeout(() => {
        autofetchLocationForLogInUser();
      }, 500);
    }
  }, [Token, ALL_ADDRESS]); */

  useEffect(() => {
    dispatch(GET_HIT_PLACE_ORDER_KEY(""));
  }, []);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  useEffect(() => {
    /* if (!Token) {
      dispatch(GET_SERVICE_TYPE(1));
      dispatch(GET_ASAP_ADVANCE_TYPE(1));
      dispatch(GET_DELIVER_PICKUP_TAB("delivery"));
      dispatch(GET_DELIVERY_PICKUP_NOW_HIT(0));
      dispatch(ASAP_DATE(new Date()));
      dispatch(GET_TIME({}));
    } */
    dispatch(GET_STATE_INFO());
  }, []);

  const autoFetchLocation = () => {
    if (navigator.geolocation) {
      try {
        console.log("Pointer 1");
        navigator.geolocation.getCurrentPosition(
          function (position) {
            //clearTimeout(location_timeout);

            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            console.log("position", position);
            if (lat && lng) {
              reverseGeocodingWithGoogle(lat, lng);
            } else {
              setTimeout(() => {
                setAddressFetching(false);
                setInitialLoader(false);
              }, 3000);
            }
          },
          function (error) {
            console.log("Errorr.....");
            if (Object.keys(DEFAULT_ADDRESS).length !== 0) {
              dispatch(GET_DEFAULT_ADDRESS(DEFAULT_ADDRESS));
              console.log("navigate 1");
              navigate("/restaurants");
            } else {
              setTimeout(() => {
                setAddressFetching(false);
                setInitialLoader(false);
                /* successToast(
                  "Turn on device location for capturing accurate address."
                ); */
              }, 3000);
            }
          }
        );
      } catch (error) {
        console.log("Location Permission issue found", navigator.userAgent);
        console.log("Location Permission issue found", error);
        setTimeout(() => {
          setAddressFetching(false);
          setInitialLoader(false);
        }, 3000);
      }
    } else {
      setTimeout(() => {
        setAddressFetching(false);
        setInitialLoader(false);
      }, 3000);
    }
  };

  const getAddressComponent = (response) => {
    let addressComponent;
    for (let add of response.results) {
      if (add.types.indexOf("street_address") !== -1) {
        addressComponent = add;
        break;
      }

      if (add.types.indexOf("premise") !== -1) {
        addressComponent = add;
        break;
      }

      if (add.types.indexOf("route") !== -1) {
        addressComponent = add;
        break;
      }
    }

    if (!addressComponent) {
      addressComponent = response?.results[0];
    }
    return addressComponent;
  };

  function reverseGeocodingWithGoogle(latitude, longitude) {
    console.log("Pointer 2", latitude, longitude);
    if (latitude && longitude) {
      //const API_KEY = GOOGLE_MAP_API_KEY;
      fetch(
        `${process.env.REACT_APP_BASE_API_URL}get-geocode-details?latitude=${latitude}&longitude=${longitude}`
      )
        .then((res) => res.json())
        .then((response) => {
          setTimeout(() => {
            setAddressFetching(false);
            setInitialLoader(false);
          }, 3000);

          const addressComponent = getAddressComponent(response);
          const zipData = addressComponent?.address_components.find(
            (components) => components.types.indexOf("postal_code") !== -1
          );

          let zipCode = zipData ? zipData?.long_name : "";
          if (zipCode) {
            if (zipCode.includes("-")) {
              const parts = zipCode.split("-");
              zipCode = parts[0];
            }
          }

          const stateData = addressComponent?.address_components.find(
            (components) =>
              components.types.indexOf("administrative_area_level_1") !== -1
          );

          const cityData = addressComponent?.address_components.find(
            (components) => components.types.indexOf("locality") !== -1
          );

          if (response?.results.length) {
            const data = {
              entry_street_address: addressComponent?.formatted_address,
              address_lat: latitude,
              address_lng: longitude,
              entry_city: cityData ? cityData?.long_name : "",
              entry_street_name_clone: addressComponent?.address_components
                ?.length
                ? addressComponent?.address_components[0]?.long_name +
                  " " +
                  addressComponent?.address_components[1]?.long_name +
                  " "
                : "",
              entry_street_name: "",
              google_place_id: addressComponent?.place_id,
              entry_postcode: zipCode,
              entry_state: stateData ? stateData?.long_name : "",
            };
            if (Object.keys(DEFAULT_ADDRESS).length !== 0) {
              dispatch(GET_DEFAULT_ADDRESS(DEFAULT_ADDRESS));
            } else {
              dispatch(GET_DEFAULT_ADDRESS(data));
            }
            console.log("navigate 2");
            navigate("/restaurants");
          }
        })
        .catch((status) => {
          setTimeout(() => {
            setAddressFetching(false);
            setInitialLoader(false);
          }, 3000);
          console.log("Request failed.  Returned status of", status);
        });
    } else {
      setTimeout(() => {
        setAddressFetching(false);
        setInitialLoader(false);
      }, 3000);
    }
  }

  const autofetchLocationForLogInUser = (addresses) => {
    console.log("Pointer 4");
    if (navigator.geolocation) {
      try {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            var lat = position.coords.latitude;
            var lng = position.coords.longitude;
            console.log("position", position);
            if (lat && lng) {
              googleCoordinatesAuthUser(lat, lng);
              return;
            } else {
              setTimeout(() => {
                setAddressFetching(false);
                setInitialLoader(false);
              }, 3000);
              return;
            }
          },
          function (error) {
            console.log("*******ERROR***********111", error);
            SavedAddressFetch(addresses);
            setTimeout(() => {
              setAddressFetching(false);
              setInitialLoader(false);
            }, 3000);
            return;
          },
          {
            enableHighAccuracy: true,
          }
        );
      } catch (error) {
        SavedAddressFetch(addresses);
        setTimeout(() => {
          setAddressFetching(false);
          setInitialLoader(false);
        }, 3000);
        return;
      }
    } else {
      SavedAddressFetch(addresses);
      setTimeout(() => {
        setAddressFetching(false);
        setInitialLoader(false);
      }, 3000);
    }
  };

  const googleCoordinatesAuthUser = (latitude, longitude) => {
    console.log("Pointer 5");
    if (latitude && longitude) {
      fetch(
        `${process.env.REACT_APP_BASE_API_URL}get-geocode-details?latitude=${latitude}&longitude=${longitude}`
      )
        .then((res) => res.json())
        .then((response) => {
          const addressComponent = getAddressComponent(response);
          const zipData = addressComponent?.address_components.find(
            (components) => components.types.indexOf("postal_code") !== -1
          );

          let zipCode = zipData ? zipData?.long_name : "";
          if (zipCode) {
            if (zipCode.includes("-")) {
              const parts = zipCode.split("-");
              zipCode = parts[0];
            }
          }

          const stateData = addressComponent?.address_components.find(
            (components) =>
              components.types.indexOf("administrative_area_level_1") !== -1
          );

          const cityData = addressComponent?.address_components.find(
            (components) => components.types.indexOf("locality") !== -1
          );

          if (response?.results.length) {
            const data = {
              entry_street_address: addressComponent?.formatted_address,
              address_lat: latitude,
              address_lng: longitude,
              entry_city: cityData ? cityData?.long_name : "",
              entry_street_name_clone: addressComponent?.address_components
                ?.length
                ? addressComponent?.address_components[0]?.long_name +
                  " " +
                  addressComponent?.address_components[1]?.long_name +
                  " "
                : "",
              entry_street_name: "",
              google_place_id: addressComponent?.place_id,
              entry_postcode: zipCode,
              entry_state: stateData ? stateData?.long_name : "",
            };

            handelCallHalfMile(data);
          } else {
            setTimeout(() => {
              setAddressFetching(false);
              setInitialLoader(false);
            }, 3000);
          }
        })
        .catch((status) => {
          setTimeout(() => {
            setAddressFetching(false);
            setInitialLoader(false);
          }, 3000);
          console.log("Request failed.  Returned status of", status);
        });
    } else {
      setTimeout(() => {
        setAddressFetching(false);
        setInitialLoader(false);
      }, 3000);
    }
  };

  const handelCallHalfMile = (data) => {
    console.log("Pointer 6");
    const params = {
      customer_lat: data.address_lat,
      customer_lng: data.address_lng,
    };
    dispatch(
      GET_NEAREST_ADDRESS({ params }, (res, loading, error) => {
        if (!error) {
          // console.log('*******Near address***********')
          console.log("res", res);
          if (Object.keys(res).length !== 0) {
            // console.log('*******Near address data***********')
            dispatch(GET_DEFAULT_ADDRESS(res));
            console.log("navigate 3");
            navigate("/restaurants");
            setTimeout(() => {
              setAddressFetching(false);
              setInitialLoader(false);
            }, 3000);
          } else {
            if (Object.keys(DEFAULT_ADDRESS).length !== 0) {
              console.log("**NOoPS1**");
              dispatch(GET_DEFAULT_ADDRESS(DEFAULT_ADDRESS));
              navigate("/restaurants");
              console.log("navigate 4");
              setTimeout(() => {
                setAddressFetching(false);
                setInitialLoader(false);
              }, 3000);
            } else if (Object.keys(data).length !== 0) {
              console.log("**NOoPS2**");
              dispatch(GET_DEFAULT_ADDRESS(data));
              console.log("navigate 5");
              navigate("/restaurants");
              setTimeout(() => {
                setAddressFetching(false);
                setInitialLoader(false);
              }, 3000);
            } else if (ALL_ADDRESS?.length !== 0) {
              if (ALL_ADDRESS[0]?.is_default_address == 1) {
                // console.log('*******default with one***********')
                if (!path) {
                  console.log("**NOoPS3**");
                  dispatch(GET_DEFAULT_ADDRESS(ALL_ADDRESS[0]));
                  console.log("navigate 6");
                  navigate("/restaurants");
                  setTimeout(() => {
                    setAddressFetching(false);
                    setInitialLoader(false);
                  }, 3000);
                }
              } else if (ALL_ADDRESS[0]?.is_default_address == 0) {
                // console.log('*******default with zero google***********')
                console.log("**NOoPS4**");
                dispatch(GET_DEFAULT_ADDRESS(ALL_ADDRESS[0]));
                console.log("navigate 7");
                navigate("/restaurants");
                setTimeout(() => {
                  setAddressFetching(false);
                  setInitialLoader(false);
                }, 3000);
              }
            } else {
              console.log("**NOoPS5**", data);
              //dispatch(GET_DEFAULT_ADDRESS(data));
              console.log("navigate 8");
              navigate("/restaurants");
              setTimeout(() => {
                setAddressFetching(false);
                setInitialLoader(false);
              }, 3000);
            }
          }
        } else {
          setTimeout(() => {
            setAddressFetching(false);
            setInitialLoader(false);
          }, 3000);
        }
      })
    );
  };

  const SavedAddressFetch = (ALL_ADDRESS) => {
    console.log("Pointer 3", ALL_ADDRESS);
    if (Object.keys(DEFAULT_ADDRESS).length !== 0) {
      dispatch(GET_DEFAULT_ADDRESS(DEFAULT_ADDRESS));
      navigate("/restaurants");
      console.log("navigate 10");
      setTimeout(() => {
        setAddressFetching(false);
        setInitialLoader(false);
      }, 3000);
    } else if (ALL_ADDRESS?.length !== 0) {
      if (ALL_ADDRESS[0]?.is_default_address == 1) {
        dispatch(GET_DEFAULT_ADDRESS(ALL_ADDRESS[0]));
        console.log("navigate 9");
        navigate("/restaurants");
        setTimeout(() => {
          setAddressFetching(false);
          setInitialLoader(false);
        }, 3000);
      } else if (ALL_ADDRESS[0]?.is_default_address == 0) {
        setTimeout(() => {
          setAddressFetching(false);
          setInitialLoader(false);
        }, 3000);
      }
    } else {
      setTimeout(() => {
        setAddressFetching(false);
        setInitialLoader(false);
      }, 3000);
    }
  };
  //************************************************************** */
  //******** LOGIN USER ADDRESS SECTION ****************************//
  //************************************************************** */
  return (
    <div>
      <ReactHelmet />
      <Header />
      {showDownloadBtn && visibilityInstall && (
        <InstallPWA setShowDownloadBtn={setShowDownloadBtn} />
      )}
      <>
        {showAddressFetching || initialLoader ? (
          <>
            {windowSize.innerWidth < 767 ? (
              <AddressAutoSplash />
            ) : (
              <div
                className="d-flex justify-content-center align-items-center default-back splace_screen lottie-container"
                style={{ height: "591px" }}
              >
                <LottiLoader loader={true} />
              </div>
            )}
          </>
        ) : (
          <>
            <>
              <OrderFromYourFavResturant />
              <Selections />
              <LocationServe />
              <NewsLetter />
            </>
          </>
        )}
      </>
      <Footer />
    </div>
  );
};

export default Home;
